import React from 'react';
import { Spin } from 'antd';
import styled from '@emotion/styled';
import { appStyles } from '../../../styles';

interface LoadingProps {
  children: React.ReactElement;
  isLoading: boolean;
  tip?: string;
}

export const Loading = (props: LoadingProps) => {
  const { children, isLoading, tip } = props;
  return (
    <StyledLoading className="loading-wrapper">
      <Spin tip={tip} spinning={isLoading} size="large">
        {children}
      </Spin>
    </StyledLoading>
  );
};

const StyledLoading = styled.div`
  ${appStyles.fullWidthHeight}
  & > div.ant-spin-nested-loading {
    ${appStyles.fullWidthHeight}
    & > div.ant-spin-container {
      ${appStyles.fullWidthHeight}
    }
    & > div > .ant-spin {
      top: 25%;
    }
  }
`;
